// Business Web team-collaboration false-failure guard (P0 — FALSE_NEGATIVE_CALL_START).
// A team call must fail only when a terminal condition for the CURRENT attempt is proven. A failure
// from an older attempt (or a slow-but-successful connection) must never raise an alert over a
// newer connecting/connected call. These are pure predicates so they can be unit-tested without a DOM.

// Suppress a start-failure when it belongs to a superseded attempt OR the call has actually progressed.
// signals: { attemptGen, currentGen, answered, connected, remoteAudio, iceConnected }
export function shouldSuppressStartFailure(signals = {}) {
  const {
    attemptGen,
    currentGen,
    answered = false,
    connected = false,
    remoteAudio = false,
    iceConnected = false,
  } = signals;
  // A failure from an older call generation can never fail the active/newer call.
  if (attemptGen != null && currentGen != null && attemptGen !== currentGen) return true;
  // Any proof the call is progressing/established cancels the failure.
  if (answered || connected || remoteAudio || iceConnected) return true;
  return false;
}

// A ring/no-answer timeout should fire only if THIS attempt is still the active one and has NOT been
// answered and the peer connection never reached a stable (answered) signaling state.
// signals: { attemptGen, currentGen, answered, signalingState }
export function shouldRaiseNoAnswer(signals = {}) {
  const { attemptGen, currentGen, answered = false, signalingState = null } = signals;
  if (attemptGen != null && currentGen != null && attemptGen !== currentGen) return false;
  if (answered) return false;
  if (signalingState === 'stable') return false; // answer already applied
  return true;
}
